var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// @ts-nocheck
import { CircularProgress, fade, Grid, makeStyles, Typography, } from '@material-ui/core';
import React, { useState, useEffect, useContext, memo } from 'react';
import { CardCvcElement, CardExpiryElement, CardNumberElement, useStripe, } from '@stripe/react-stripe-js';
import { nanoid } from 'nanoid';
import TCardContext, { ACTIONS } from '../TCardContext';
import CardsIcon from '@dev-togetherprice/icons.cards';
import { getRecaptcha } from '@dev-togetherprice/api.captcha';
import { fetchFinancial } from '@dev-togetherprice/api.services';
import { useCard } from '@dev-togetherprice/api.financial';
import { dispatchPixel } from '@dev-togetherprice/utils.pixel';
import { updateFunnel } from '@dev-togetherprice/api.user';
const useStyles = makeStyles((theme) => ({
    root: {
        position: 'relative',
        width: '100%',
    },
    form: {
        marginTop: theme.spacing(2),
        backgroundColor: fade(theme.palette.primary.light, 0.2),
        padding: theme.spacing(4),
        borderRadius: theme.spacing(2.5),
    },
    label: {
        fontWeight: 400,
        marginBottom: theme.spacing(1),
        width: '100%',
    },
    cardDescription: {},
    cards: {
        height: 24,
        width: 75,
    },
    icon: {
        width: 50,
        height: 16,
    },
    input: {
        height: 55,
        borderRadius: theme.spacing(2),
        border: `1px solid ${fade(theme.palette.primary.main, 0.3)}`,
        padding: theme.spacing(0, 4),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: '100%',
        backgroundColor: 'white',
        fontWeight: 400,
    },
    item: {
        width: '48%',
    },
    cardNumber: {
        marginBottom: theme.spacing(4),
    },
    error: {
        fontSize: 10,
        padding: theme.spacing(1),
    },
    loader: {
        position: 'absolute',
        top: 0,
        left: 0,
        backgroundColor: 'rgba(255,255,255, .4)',
        width: '100%',
        height: '100%',
    },
}));
const TCardForm = ({ onSave }) => {
    const { state: { captcha, onError, t, captchaToken, noSave, onSelect }, dispatch, } = useContext(TCardContext);
    const { data: card, mutate } = useCard();
    const [isLoading, setIsLoading] = useState(false);
    const [cardRef, setCardRef] = useState();
    const classes = useStyles();
    const stripe = useStripe();
    const [isCompleted, setIsCompleted] = useState({ cardNumber: false, cardExpiry: false, cardCvc: false });
    const [errors, setErrors] = useState({});
    const handleChange = (e) => {
        const { error, complete, elementType } = e;
        setErrors((prev) => (Object.assign(Object.assign({}, prev), { [elementType]: (error === null || error === void 0 ? void 0 : error.message) || false })));
        setIsCompleted((prev) => (Object.assign(Object.assign({}, prev), { [elementType]: complete })));
    };
    const handleError = (error) => {
        var _a, _b;
        const message = ((_a = error.error) === null || _a === void 0 ? void 0 : _a.message) ||
            ((_b = error === null || error === void 0 ? void 0 : error.data) === null || _b === void 0 ? void 0 : _b.message) ||
            t('error', { error: JSON.stringify(error) });
        onError(message);
        console.error(error);
        return null;
    };
    const wait = (ms) => new Promise((resolve, reject) => {
        setTimeout(resolve, ms);
    });
    const poll = (count) => __awaiter(void 0, void 0, void 0, function* () {
        if (count >= 5)
            return null;
        if (card)
            return card;
        mutate();
        yield wait(200);
        return poll(count + 1);
    });
    const prepareCard = () => __awaiter(void 0, void 0, void 0, function* () {
        let tempCaptchaToken = captchaToken;
        yield updateFunnel({ column: 'insert_credit_card' });
        if (!captchaToken) {
            const captchaRes = yield getRecaptcha(captcha.current).catch(handleError);
            if (!captchaRes ||
                (captchaRes === null || captchaRes === void 0 ? void 0 : captchaRes.status) !== 'SUCCESS' ||
                !(captchaRes === null || captchaRes === void 0 ? void 0 : captchaRes.token)) {
                return [false, false];
            }
            dispatch({ type: ACTIONS.SET_CAPTCHA_TOKEN, payload: captchaRes.token });
            tempCaptchaToken = captchaRes.token;
        }
        const cardSetupSecret = yield fetchFinancial('/getClientSecretForCardSetupV2', null, { noDefaultHeader: true });
        if (!cardSetupSecret || !cardSetupSecret.secret)
            return [false, false];
        const stripeRes = yield stripe
            .confirmCardSetup(cardSetupSecret.secret, {
            payment_method: {
                card: cardRef,
            },
        })
            .catch(handleError);
        if (!stripeRes || !(stripeRes === null || stripeRes === void 0 ? void 0 : stripeRes.setupIntent)) {
            handleError(stripeRes);
            return [false, false];
        }
        return [tempCaptchaToken, stripeRes];
    });
    const updateCard = () => __awaiter(void 0, void 0, void 0, function* () {
        const [captchaRes, stripeRes] = yield prepareCard().catch(handleError);
        if (!captchaRes || !stripeRes)
            return false;
        yield fetchFinancial('/changeCard', {
            method: 'POST',
            body: JSON.stringify({
                idempotencyId: nanoid(),
                paymentMethodId: stripeRes.setupIntent.payment_method,
            }),
            headers: {
                'Captcha-Token': captchaRes,
            },
        })
            .then(() => {
            mutate();
            dispatch({ type: ACTIONS.SHOW_CARD_FORM, payload: false });
        })
            .catch(handleError);
    });
    const saveCard = () => __awaiter(void 0, void 0, void 0, function* () {
        const [captchaRes, stripeRes] = yield prepareCard();
        if (!captchaRes || !stripeRes)
            return false;
        yield fetchFinancial('/saveCard', {
            method: 'POST',
            body: stripeRes.setupIntent.payment_method,
            headers: {
                'content-type': 'text/plain',
                'Captcha-Token': captchaRes,
            },
        }, { noDefaultHeader: true })
            .then(() => __awaiter(void 0, void 0, void 0, function* () {
            dispatchPixel('save-card');
            yield poll(0);
            yield onSave();
            yield updateFunnel({ column: 'credit_card_saved' });
            dispatch({ type: ACTIONS.SHOW_CARD_FORM, payload: false });
        }))
            .catch(handleError);
    });
    useEffect(() => {
        if (Object.values(isCompleted).every((val) => val)) {
            setIsLoading(true);
            if (!noSave) {
                dispatch({ type: ACTIONS.SHOW_TEST_CARD, payload: false });
                if (card) {
                    updateCard().finally(() => setIsLoading(false));
                }
                else {
                    saveCard().finally(() => setIsLoading(false));
                }
            }
            else {
                // test card informations
                onSelect({ type: 'CARD' });
                dispatch({ type: ACTIONS.SHOW_TEST_CARD, payload: true });
                dispatch({ type: ACTIONS.SHOW_CARD_FORM, payload: false });
                setIsLoading(false);
            }
        }
        return () => {
            setIsLoading(false);
        };
    }, [isCompleted]);
    return (React.createElement(Grid, { className: classes.root },
        React.createElement(Grid, { className: classes.cardDescription, container: true, direction: 'row', alignItems: 'center' },
            React.createElement(Typography, { variant: 'body2', color: 'textSecondary' }, t('canUse')),
            React.createElement(CardsIcon, { className: classes.cards })),
        React.createElement(Grid, { className: classes.form, container: true, direction: 'column' },
            React.createElement(Grid, { className: classes.cardNumber, container: true, direction: 'column' },
                React.createElement(Typography, { className: classes.label, variant: 'caption', color: 'textPrimary' }, t('cardNumber')),
                React.createElement(CardNumberElement, { onReady: (el) => setCardRef(el), className: classes.input, onChange: handleChange, options: {
                        placeholder: card
                            ? t('cardPlaceholder', { last4: card === null || card === void 0 ? void 0 : card.last4 })
                            : 'XXXX XXXX XXXX XXXX',
                    } }),
                errors.cardNumber && (React.createElement(Typography, { variant: 'body2', color: 'error', className: classes.error }, errors.cardNumber))),
            React.createElement(Grid, { container: true, direction: 'row', justifyContent: 'space-between', alignItems: 'flex-start' },
                React.createElement(Grid, { className: classes.item },
                    React.createElement(Typography, { className: classes.label, variant: 'caption', color: 'textPrimary' }, t('expirationDate')),
                    React.createElement(CardExpiryElement, { className: classes.input, onChange: handleChange, options: {
                            placeholder: card
                                ? `${card === null || card === void 0 ? void 0 : card.expMonth}/${card === null || card === void 0 ? void 0 : card.expYear}`
                                : 'MM/YY',
                        } }),
                    errors.cardExpiry && (React.createElement(Typography, { variant: 'body2', color: 'error', className: classes.error }, errors.cardExpiry))),
                React.createElement(Grid, { item: true, className: classes.item },
                    React.createElement(Typography, { className: classes.label, variant: 'caption', color: 'textPrimary' }, t('securityCode')),
                    React.createElement(CardCvcElement, { className: classes.input, onChange: handleChange, options: { placeholder: 'CVC' } }),
                    errors.cardCvc && (React.createElement(Typography, { variant: 'body2', color: 'error', className: classes.error }, errors.cardCvc))))),
        isLoading && (React.createElement(Grid, { container: true, alignItems: 'center', justifyContent: 'center', className: classes.loader },
            React.createElement(CircularProgress, { size: 50 })))));
};
export default memo(TCardForm);
